import useWindowDimensions from '@src/Common/Hooks/useWindowDimensions';
import React, { memo } from 'react';
import ContentLoader from 'react-content-loader';
import styles from './SkeletonTimelineDetail.module.scss';

const SkeletonTimelineDetail = () => {
  const { width } = useWindowDimensions();
  const widthContainer = width > 768 ? 180 : 120;
  const heightContainer = width > 768 ? 120 : 90;
  return (
    <ContentLoader
      data-testid="SkeletonTimelineDetail-Default"
      uniqueKey="SkeletonTimelineDetail-Default"
      speed={1}
      width={widthContainer}
      height={heightContainer}
      viewBox={`0 0 ${widthContainer} ${heightContainer}`}
      backgroundColor="#0e1931"
      foregroundColor="#142e3d"
      className={styles['Container']}
    >
      <rect x="0" y="0" rx="3" ry="3" width={width * 0.2} height="14" />
      <rect x="2" y="25" rx="3" ry="3" width={width * 0.2} height="14" />
      <rect x="30" y="50" rx="3" ry="3" width="300" height="14" />
      <rect x="10" y="75" rx="3" ry="3" width={width * 0.2} height="14" />
    </ContentLoader>
  );
};

export default memo(SkeletonTimelineDetail);
